export enum ENV
{
    PRODUCTION = 'production',
    BETA = 'beta',
    GAMMA = 'gamma',
    DEVELOPMENT = 'development'
}

export enum REGION
{
    TEST = 'test',
    NA = 'NA',
    EU = 'EU',
    NRT = 'NRT'
}

type ApiHost = {
    [key in ENV]: { [key in REGION]?: string };
};
export const API_HOST: ApiHost = {
    [ ENV.PRODUCTION ]: {
        [ REGION.NA ]: 'https://as0qgpqjrd.execute-api.us-east-1.amazonaws.com/prod-NAFulfillment',
        [ REGION.EU ]: 'https://26avz7iasl.execute-api.eu-west-1.amazonaws.com/prod-EUFulfillment',
        [ REGION.NRT ]: 'https://f9yqhjhn92.execute-api.ap-northeast-1.amazonaws.com/prod-NRTFulfillment',
    },
    [ ENV.BETA ]: {
        [ REGION.TEST ]: 'https://ppdnumsfy8.execute-api.us-west-2.amazonaws.com/beta',
    },
    [ ENV.DEVELOPMENT ]: {
        [ REGION.TEST ]: 'https://ctm8pxjp65.execute-api.us-west-2.amazonaws.com/dev-hop',
    },
    [ ENV.GAMMA ]: {
        [ REGION.NA ]: 'https://v2bzeiaopj.execute-api.us-east-1.amazonaws.com/gamma',
    },
};
export const BACKEND_API_HOST: ApiHost = {
    [ ENV.PRODUCTION ]: {
        [ REGION.NA ]: 'https://dh5hogwwzc.execute-api.us-east-1.amazonaws.com/prod-NAFulfillment',
        [ REGION.EU ]: 'https://x0yziek7x2.execute-api.eu-west-1.amazonaws.com/prod-EUFulfillment',
        [ REGION.NRT ]: 'https://vlgl3a7enj.execute-api.ap-northeast-1.amazonaws.com/prod-NRTFulfillment',
    },
    [ ENV.BETA ]: {
        [ REGION.TEST ]: 'https://a6novyvs06.execute-api.us-west-2.amazonaws.com/beta',
    },
    [ ENV.DEVELOPMENT ]: {
        [ REGION.TEST ]: 'https://a6novyvs06.execute-api.us-west-2.amazonaws.com/beta',
    },
    [ ENV.GAMMA ]: {
        [ REGION.NA ]: 'https://18b15p7cn7.execute-api.us-east-1.amazonaws.com/gamma',
    },
};

//export const API_PREFIX = '/service/com.amazon.aftnewtondashboardbackendlambda.AFTNewtonDashboardBackendLambda/operation';
export const API_PREFIX = '';


export const REGION_CODE = {
    [ REGION.TEST ]: 'us-west-2',
    [ REGION.NA ]: 'us-east-1',
    [ REGION.EU ]: 'eu-west-1',
    [ REGION.NRT ]: 'ap-northeast-1',
};


export const MIDWAY_URL = 'https://midway-auth.amazon.com/SSO';

export const MIDWAY_LOGIN_URL = 'https://midway-auth.amazon.com/login';

export const AFTX_DOMAIN: ApiHost = {
    [ ENV.PRODUCTION ]: {
        [ REGION.NA ]: 'https://newton.na.aftx.amazonoperations.app',
        [ REGION.EU ]: 'https://newton.eu.aftx.amazonoperations.app',
        [ REGION.NRT ]: 'https://newton.nrt.aftx.amazonoperations.app',
    },
    [ ENV.BETA ]: {
        [ REGION.TEST ]: 'https://newton.na.integ.aftx.amazonoperations.app',
    },
    [ ENV.DEVELOPMENT ]: {
        [ REGION.TEST ]: '',
    },
    [ ENV.GAMMA ]: {
        [ REGION.NA ]: 'https://newton-gamma.na.aftx.amazonoperations.app',
    },
};
